export const getStickyOffset = isExtended => {
  const offset = Object.freeze({
    desktop: isExtended ? 0 : 35,
    mobile: isExtended ? 0 : 49,
  });

  return offset;
};

export default getStickyOffset;
